import { isNativeAndroid } from './android';
import { isNativeIOS } from './ios';

export function isNativeApp(): boolean {
  return isNativeAndroid() || isNativeIOS();
}

export function canVibrate(): boolean {
  if (typeof window === 'undefined') return false;

  // vibrate isn't present on IOS
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return navigator.vibrate != null && navigator.userActivation?.hasBeenActive;
}

export function vibrate(pattern: VibratePattern): void {
  if (canVibrate()) {
    navigator.vibrate(pattern);
  }
}
